import React from 'react';

import { Column } from 'components/Layout/Grid';
import FollowUpSlider from '..';
import { FollowUpEnum } from '../model';

const FollowUpNotDelivered: React.FC = () => (
  <>
    <Column className="w-100 max-w-lg-100 flex-1 px-0">
      <FollowUpSlider showTypeDateFilter={false} typeFollowUp={FollowUpEnum.NOT_DELIVERED} />
    </Column>
  </>
);

export default FollowUpNotDelivered;
